<template>
  <div class="certificate">
    <img
      class="certificate-banner"
      src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/banner.png"
      alt
    />
    <!-- 师资培训 布局样式 -->

    <div class="w-video">
      <div style="height: 60px;"></div>
      <div class="video-title">
        <span style="font-size: 30px;color: #333333;font-weight: bold;">课程视频</span>
        <br />
        <span style="font-size: 16px;color: #999999;">COURSE VIDEO</span>
      </div>
      <div class="video">
        <div class="fanhui" @click="fanhui()">返回上一页</div>
        <!-- 课程视频-主播放窗口 -->
        <div style="position: relative;z-index: 1;">
          <video
            id="movie"
            class="video-main"
            :src="videoList[playIndex].video"
            controls="controls"
            controlslist="nodownload"
          ></video>
          <div class="video-main-title">{{videoList[playIndex].title}}</div>
          <div class="video-show" @click="videoPlay()">
            <img v-if="videoFlag" class="bofang1" src="../../assets/1+X/bofang1.png" alt />
          </div>
          <!-- 课程视频-右侧列表 -->
          <div v-if="jiantouFlag" @click="suojin()" class="jiantou">
            <img src="../../assets/right32.png" alt />
          </div>
          <div v-else @click="suojin()" class="jiantou1">
            <img src="../../assets/left32.png" alt />
          </div>
          <div v-show="jiantouFlag" class="video-mini" @mousewheel="wheel()">
            <ul>
              <li
                v-for="(item,index) in videoList"
                v-if="index >= videoIndex"
                :key="index"
                @click="change(index)"
              >
                <img :src="item.img" />
                <img class="video-mini-img" src="../../assets/1+X/bofang2.png" />
                <div
                  :class="index==playIndex ? 'video-mini-title1' : 'video-mini-title'"
                >{{item.title}}</div>
              </li>
            </ul>
            <div class="arrow-up" @click="arrowUp">
              <span class="revolve"><</span>
            </div>
            <div class="arrow-down" @click="arrowDown">
              <span class="revolve">></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//禁止此页的右键事件
document.oncontextmenu = function () {
  return false;
};

export default {
  components: {},
  data() {
    return {
      mouseFlag: false,
      jiantouFlag: true,
      index: 0,
      videoIndex: 0, //video-mini-list开始下标
      playIndex: 0, //video-main所显示播放列表中的视频内容
      videoFlag: true, //控制ideo-main的播放图标 true显示 false不显示
      /**
       * img:视频列表显示的图片
       * video:主播放窗口的视频链接
       * title:视频列表及主播放窗口下显示的文字
       *
       * 后台没有相关模块  更新需要修改页面数据
       */
      videoList: [
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/img/50MW_1.png",
          video:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/50MW 母管制系统机组仿真（汽机）（一）.mp4",
          title: "1.50MW 母管制系统机组仿真（汽机）（一）",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/img/50MW_2.png",
          video:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/50MW 母管制系统机组仿真（汽机）（二）.mp4",
          title: "2.50MW 母管制系统机组仿真（汽机）（二）",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/img/50MW_3.png",
          video:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/50MW 母管制系统机组仿真（锅炉）（一）.mp4",
          title: "3.50MW 母管制系统机组仿真（锅炉）（一）",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/img/50MW_4.png",
          video:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/50MW 母管制系统机组仿真（锅炉）（二）.mp4",
          title: "4.50MW 母管制系统机组仿真（锅炉）（二）",
        },
        {
          img: "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/img/50MW_5.png",
          video:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/train_no2/50MW 循环硫化床机组电气系统.mp4",
          title: "5.50MW 循环硫化床机组电气系统",
        }
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.index = localStorage.getItem("index");
    //console.log(this.index);
    //在mounted()方法里监听mousewheel；
    // chrome and ie
    window.addEventListener("mousewheel", this.handleScroll, false);
    //// firefox
    window.addEventListener("DOMMouseScroll", this.handleScroll, false);
  },
  methods: {
    //师资培训-右侧视频列表下滑动
    arrowDown() {
      if (this.videoList.length - this.videoIndex > 4) {
        this.videoIndex = this.videoIndex + 1;
      }
    },
    //师资培训-右侧视频列表上滑动
    arrowUp() {
      if (this.videoIndex > 0) {
        this.videoIndex = this.videoIndex - 1;
      }
    },
    //师资培训-右侧视频列表点击播放事件
    change(n) {
      if (n != this.playIndex) {
        this.playIndex = n;
        this.videoFlag = true;
      }
    },
    //控制播放器播放，取消播放按钮样式
    videoPlay() {
      var video = document.getElementById("movie");
      video.play();
      this.videoFlag = false;
    },
    suojin() {
      if (this.jiantouFlag) {
        this.jiantouFlag = false;
      } else {
        this.jiantouFlag = true;
      }
    },
    fanhui() {
      this.$router.go(-1); //返回上一层
    },
    handleScroll(e) {
      //console.log("滑动了。。。");
      var direction = e.deltaY > 0 ? "down" : "up"; //该语句可以用来判断滚轮是向上滑动还是向下
      if (document.getElementsByTagName("li").length == 1) {
        //此处决定无论一次滚轮滚动的距离是多少，此事件
        //都得等上次滚动结束，才会执行本次
        this.isShow = false;
        setTimeout(() => {
          this.isShow = true;
          ++this.nowIndex;
          if (this.nowIndex == 3) {
            this.nowIndex = 0;
          }
        }, 10);
      }
    },
    wheel() {
      //console.log("vue滚动。。。");
    },
  },
};
</script>

<style scoped>
.certificate {
  position: relative;
}

.certificate-banner {
  width: 100%;
  height: 450px;
}

.train {
  width: 1200px;
  margin: 0 auto;
}

.w-video {
  background-color: #ededed;
  padding-bottom: 40px;
}

.video {
  /* border-radius:10px;
		-moz-box-shadow:0 0 8px #c2c2c2;
		-webkit-box-shadow:0 0 8px #c2c2c2;
		box-shadow:0 0 8px #c2c2c2; */
  padding: 50px;
  display: flex;
  justify-content: space-between;
  margin: auto auto;
  width: 946px;
  height: 532px;
}

.video-title,
.course-title {
  /* padding-top: 30px; */
  margin-top: 60px;
  margin-bottom: 40px;
  text-align: center;
}

.video-title {
  margin-top: 0;
  margin-bottom: 10px;
}

.video-show {
  height: 92px;
  width: 92px;
  margin: -265px 0 0 427px;
  position: relative;
  z-index: 3;
  display: block;
}

.video-hidden {
  height: 92px;
  width: 92px;
  margin: -313.5px 0 0 427px;
  position: relative;
  z-index: 3;
  display: none;
}

.video-main {
  height: 532px;
  width: 946px;
  background-color: #999999;
}

.video-main-title {
  font-size: 24px;
  color: #ffffff;
  position: relative;
  z-index: 2;
  margin-top: -95px;
  margin-left: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.bofang1:hover {
  cursor: pointer;
}

.video-mini {
  width: 225px;
  height: 532px;
  position: relative;
  margin-top: -412px;
  margin-left: 721px;
}

.video-mini ul {
  overflow: hidden;
  width: 225px;
  height: 532px;
}

.video-mini li {
  height: 126px;
  width: 225px;
  background: #999999;
  position: relative;
  cursor: pointer;
  margin-bottom: 10px;
}

.video-mini-title {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  letter-spacing: 1px;
  font-size: 14px;
  color: #ffffff;
  z-index: 3;
  position: absolute;
  margin-top: -22px;
  margin-left: 6px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.video-mini-title1 {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  letter-spacing: 1px;
  font-size: 14px;
  color: #f25b20;
  z-index: 3;
  position: absolute;
  margin-top: -22px;
  margin-left: 6px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.video-mini-img {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  letter-spacing: 1px;
  font-size: 14px;
  z-index: 3;
  position: absolute;
  margin-top: -76px;
  margin-left: 102px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.arrow-up {
  position: absolute;
  width: 225px;
  height: 25px;
  background: #fffafa;
  margin-top: -565px;
  text-align: center;
  cursor: pointer;
}

.arrow-down {
  width: 225px;
  height: 25px;
  background: #fffafa;
  position: absolute;
  margin-top: 6px;
  text-align: center;
  cursor: pointer;
}

.jiantou {
  position: relative;
  margin-left: 696px;
  margin-top: 80px;
}

.jiantou1 {
  position: relative;
  margin-left: 920px;
  margin-top: 80px;
}

.jiantou:hover {
  cursor: pointer;
}

.jiantou1:hover {
  cursor: pointer;
}

.revolve {
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  display: block;
  color: #2d73d9;
  font-size: 20px;
  width: 25px;
  margin: auto;
}

.title-page {
  display: flex;
  justify-content: space-between;
  width: auto;
  padding: 0px 20px 0px 75px;
  margin: 90px 0px 70px;
}

.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}

.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}

/* .down-list {
		min-height: 350px;
	} */

.down-item {
  height: 80px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #cccccc solid;
  line-height: 80px;
}

.icon {
  width: 26px;
  height: 26px;
}

.down-item-left {
  color: #333333;
  margin-left: 20px;
}

.down-item-left img {
  margin-top: -4px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 20px;
}

.down-item-right {
  margin: auto 0;
  margin-right: 20px;
}

.down-item-right p {
  width: 136px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 2px solid #0055d3;
  border-radius: 30px;
  background: #fff;
  cursor: pointer;
}

.down-item-right p:hover {
  background: #0055d3;
  color: #fff;
}

.fanhui {
  display: inline-block;
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
  padding: 10px 12px;
  margin-left: -107px;
  margin-top: -115px;
  position: absolute;
}

.fanhui:hover {
  color: #528ce0;
  cursor: pointer;
  border: 1px solid #dae6ff;
}
</style>
